import { buildModelManager } from "../builder.js";
const DefaultGeneratedEcgSelection = {
  __typename: true,
  id: true,
  abnormalities: true,
  accessCount: true,
  createdAt: true,
  ecgFile: { url: true, mimeType: true, fileName: true },
  fileSize: true,
  generationMetadata: true,
  heartRate: true,
  isTest: true,
  layout: true,
  linkedScenarioId: true,
  linkedSimulationId: true,
  patientAge: true,
  patientSex: true,
  rhythm: true,
  title: true,
  updatedAt: true
};
const modelApiIdentifier = "generatedEcg";
const pluralModelApiIdentifier = "generatedEcgs";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultGeneratedEcgSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultGeneratedEcgSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultGeneratedEcgSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultGeneratedEcgSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultGeneratedEcgSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultGeneratedEcgSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultGeneratedEcgSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createGeneratedEcg",
    operationReturnType: "CreateGeneratedEcg",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      generatedEcg: { required: false, type: "CreateGeneratedEcgInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultGeneratedEcgSelection
  },
  {
    type: "action",
    operationName: "bulkCreateGeneratedEcgs",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateGeneratedEcgsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultGeneratedEcgSelection
  },
  {
    type: "action",
    operationName: "updateGeneratedEcg",
    operationReturnType: "UpdateGeneratedEcg",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      generatedEcg: { required: false, type: "UpdateGeneratedEcgInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultGeneratedEcgSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateGeneratedEcgs",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateGeneratedEcgsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultGeneratedEcgSelection
  },
  {
    type: "action",
    operationName: "deleteGeneratedEcg",
    operationReturnType: "DeleteGeneratedEcg",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteGeneratedEcgs",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertGeneratedEcg",
    operationReturnType: "UpsertGeneratedEcg",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      generatedEcg: { required: false, type: "UpsertGeneratedEcgInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateGeneratedEcgResult": { hasReturnType: false },
      "... on UpdateGeneratedEcgResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultGeneratedEcgSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertGeneratedEcgs",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertGeneratedEcgsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultGeneratedEcgSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "generatedEcgGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const GeneratedEcgManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultGeneratedEcgSelection,
  operations
);
export {
  DefaultGeneratedEcgSelection,
  GeneratedEcgManager
};
//# sourceMappingURL=GeneratedEcg.js.map
